module.exports = __webpack_public_path__ + "static/img/zcym.52aadf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zcym.jpg
// module id = cRKJ
// module chunks = 4